import { HTTP } from './network'

export const categoriaService = {
  getAll() {
    return HTTP.get('/categoria')
  },
}
